import React, { ReactNode } from "react";
import { Typography, Drawer, Box, ClickAwayListener } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { styled, useTheme } from "@mui/material/styles";
import { PlacedPosition } from "../../utils/enum/enum";
import customTheme from "../../theme/customTheme";

export default function FilterPanel({
  open,
  handleClose,
  children,
}: {
  open: boolean;
  handleClose: () => void;
  children?: ReactNode;
}) {
  const DrawerHeader = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  }));
  const theme = useTheme();
  const CONSTANT_SPACING = 4;
  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={() => open && handleClose()}
    >
      <Drawer
        open={open}
        sx={{
          "& .MuiDrawer-paper": {
            width: "30%",
          },
        }}
        variant="persistent"
        anchor={PlacedPosition.LEFT}
      >
        <DrawerHeader>
          <IconButton
            onClick={handleClose}
            sx={{
              padding: CONSTANT_SPACING,
              "&:hover": {
                backgroundColor: "transparent",
                color: customTheme.palette.primary.main,
              },
            }}
          >
            {theme.direction === "ltr" && <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Box
          sx={{
            pb: CONSTANT_SPACING,
            pl: CONSTANT_SPACING,
            pr: CONSTANT_SPACING,
          }}
        >
          <Typography variant="h5">
            Filter Options
          </Typography>
          {children}
        </Box>
      </Drawer>
    </ClickAwayListener>
  );
}